<template>
    <div style="min-width:75%;">
        <h2 id="courses-title" class='h1 text-secondary mb-5'>{{ section.name }}</h2>

        <ul class="mt-3" style="font-size:1.2rem; line-height:2rem; color:#555;">
            <li class="mb-5" v-for="(course, courseIdx) in datas.courses" :key="'course_' + courseIdx">
                <div class='row'>
                    <div class="col-sm-6">
                        <span class="text-secondary">{{ course.name }}</span>
                    </div>
                    <div class="col-sm-4 col-6 text-start">
                        <span class="text-danger">{{ course.level }}</span>
                    </div>
                    <div class="col-sm-2 col-6 text-end">
                        <span class="text-success">{{ course.from }} - {{ course.to }}</span>
                    </div>
                </div>

                <div class='text-primary options'>
                    {{ course.location }}
                </div>
            </li>
        </ul>



    </div>
</template>

<script>
export default {
    // name
    name: 'SectionCourses',
    // components
    components: {
    },
    // props
    props : {
        section : { type : Object, required : true }
    },
    // data
    data : function() {
        return {

        }
    },
    mounted : function() {

    },
    methods : {

    },
    computed : {
    }
}
</script>

<style scoped>
.options {
    font-size:1rem;
    line-height:1.5rem;
}
</style>
